import Spinner from "./Spinner.component.jsx";

export default Spinner;